"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _Contexts = require("./Contexts");

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _Errors = require("./Errors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useTouched(paths) {
  const {
    touched
  } = (0, _Contexts.useFormContext)(_Contexts.BITS.touched);
  const memoFilterAndMapErrors = (0, _react.useMemo)(() => (0, _memoizeOne.default)(_Errors.filterAndMapErrors, ([a], [b]) => a.errors === b.errors && a.names === b.names && a.mapErrors === b.mapErrors), []);
  return paths ? memoFilterAndMapErrors({
    errors: touched,
    names: paths
  }) : touched;
}

var _default = useTouched;
exports.default = _default;